import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { IBuilderSchema } from '../../../types';
import { BuilderIcon } from '../../common/icons';
import { Card } from '../card';

export interface IBuilderLayoutStateProps {
  builderName: IBuilderSchema['name'];
  logoUrl: IBuilderSchema['logoUrl'];
}

interface IBuilderLayoutOwnProps {
  isInjected?: boolean;
}

type TBuilderLayoutProps = IBuilderLayoutOwnProps & IBuilderLayoutStateProps;

export class BuilderLayout extends React.Component<TBuilderLayoutProps> {
  public render() {
    const { builderName, logoUrl, isInjected = false } = this.props;

    if (!builderName) {
      return null;
    }

    const WrapperComponent: typeof React.Component = isInjected ? ('div' as unknown as typeof React.Component) : Card;

    return (
      <WrapperComponent {...mergeStyles(styles['container'], isInjected && styles['container--injected'])}>
        {logoUrl && <img className={styles['logo']} src={logoUrl} />}
        <div className={styles['builder']}>
          <div className={styles['title']}>{builderName}</div>
          <span>
            <span className={styles['icon']}>
              <BuilderIcon />
            </span>
            <span className={styles['text']}>Застройщик</span>
          </span>
        </div>
      </WrapperComponent>
    );
  }
}
